<li class="callus list-inline-item" [class]="{'internal': internalPage, 'no-border': border}">
	<span>{{'callus.label' | translate}}: </span>
	<a class="callus-link" [href]="phoneLink" target="_blank" rel="noopener noreferrer">{{phone}}</a>
</li>
